import React, { useContext, useEffect } from "react";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Container, Paper, styled } from '@mui/material';
import globalContext from '../context/context'

import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import CartStepOne from '../components/cart/CartStepOne';
import CartStepTwo from '../components/cart/CartStepTwo';
import CartPayment from "../components/cart/CartPayment";
import CartTimer from "../utils/CartTimer";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const steps = ['PersonalData', 'Overview', 'Pay'];

const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#d93e45',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#d93e45',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
        color: '#d93e45',
    }),
    '& .QontoStepIcon-completedIcon': {
        color: '#d93e45',
        zIndex: 1,
        fontSize: 16,
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: '#d93e45',
        color: '#fff',
        textAlign: 'center',
        fontWeight: 600

    },
    '& .QontoStepIcon-circle': {
        width: 20,
        height: 20,
        color: '#fff',
        borderRadius: '50%',
        backgroundColor: '#eaeaf0',
        textAlign: 'center',
        fontWeight: 600

    },
}));

function QontoStepIcon(props) {
    const { active, completed, className, icon } = props;
    return (
        <QontoStepIconRoot ownerState={{ active }} className={className}>
            {completed ? (<Box className="QontoStepIcon-completedIcon">
                {icon}
            </Box>
            ) : (
                <Box className="QontoStepIcon-circle" >{icon}</Box>
            )}
        </QontoStepIconRoot>
    );
}



function Cart() {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const { contextData: { details, cart, formValues }, isLoggedIn, setSnack } = useContext(globalContext);

    useEffect(() => {
        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );
        const step = new URLSearchParams(window.location.search).get(
            "step"
        );

        if (clientSecret) {
            setActiveStep(2);
        } else if (step && !isNaN(parseInt(step))) {
            setActiveStep(parseInt(step));
        }
    }, [])

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        if (activeStep === 0) {
            if (!details?.flightNumber || details.flightNumber.trim() === '') {
                setSnack({
                    message: t('cart.flightNumberRequired'),
                    severity: 'error',
                    open: true
                });
                return;
            }
            if (!formValues?.singleTrip && (!details?.flightNumber2 || details.flightNumber2.trim() === '')) {
                setSnack({
                    message: t('cart.flightNumberRequired'),
                    severity: 'error',
                    open: true
                });
                return;
            }
        }

        if (!isLoggedIn()) {
            setSnack({
                message: t('cart.pleaseLogin'),
                severity: 'error',
                open: true
            })
        } else {
            let newSkipped = skipped;
            if (isStepSkipped(activeStep)) {
                newSkipped = new Set(newSkipped.values());
                newSkipped.delete(activeStep);
            }

            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
        }

    };

    const handleBack = () => {
        if(activeStep===0){
            navigate('/transfer');
        } else{
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };


    const handleReset = () => {
        setActiveStep(0);
    };


    return (
        <>
            <Box sx={{ py: 5, bgcolor: 'rgba(0,0,0, .2)' }}>
                <Container>
                    <Paper sx={{ p: { xs: 1.5, md: 3 }, bgcolor: '#fff', m: { xs: 0, md: 3 } }}>
                        <Typography sx={{ fontSize: { xs: '24px', md: '32px' }, fontWeight: 300, textAlign: 'center', pb: 2 }}>
                            {t('cart.cart')}
                            <CartTimer time={cart?.createdDate} />
                            
                        </Typography>
                        <Box sx={{ width: '100%' }}>
                            <Stepper
                                alternativeLabel
                                connector={<QontoConnector />}
                                activeStep={activeStep}>
                                {steps.map((label, index) => {
                                    const stepProps = {};
                                    const labelProps = {};
                                    if (isStepSkipped(index)) {
                                        stepProps.completed = false;
                                    }
                                    return (
                                        <Step key={label} {...stepProps}>
                                            <StepLabel StepIconComponent={QontoStepIcon} {...labelProps}> {t(`cart.step${label}`)}</StepLabel>
                                        </Step>
                                    );
                                })}
                            </Stepper>
                            {activeStep === steps.length ? (
                                <React.Fragment>
                                    <Typography sx={{ mt: 2, mb: 1 }}>
                                        All steps completed - you&apos;re finished
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                        <Box sx={{ flex: '1 1 auto' }} />
                                        <Button onClick={handleReset}>Reset</Button>
                                    </Box>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {
                                        activeStep == 0 && (<CartStepOne />)
                                    }
                                    {
                                        activeStep == 1 && (<CartStepTwo />)
                                    }
                                    {
                                        activeStep == 2 && (<CartPayment />)
                                    }
                                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                        <Button
                                            color="inherit"
                                            onClick={handleBack}
                                            sx={{ mr: 1 }}
                                        >
                                            {t('cart.back')}
                                        </Button>
                                        <Box sx={{ flex: '1 1 auto' }} />

                                        {activeStep !== steps.length - 1 && <Button variant="contained" sx={{
                                            bgcolor: 'rgba(235,64,129,1)',
                                            borderRadius: '0',
                                            "&:hover": {
                                                bgcolor: 'rgba(235,64,129,.6)'
                                            }
                                        }} onClick={handleNext}>
                                            {t('cart.next')}
                                        </Button>}
                                    </Box>
                                </React.Fragment>
                            )}
                        </Box>
                    </Paper>
                </Container>
            </Box>
        </>
    );
}
export default Cart;